module.exports = __webpack_public_path__ + "images/feature/data-export-1-7b3c9bb06c016754dadb5756531e4a51.png";